import Model from '../Model'
import moment from "moment";

export default class DailyBriefing extends Model {

    getDownloadUrl() {
        return route('api.v2.hsqe.daily-briefings.pdf', [this.packageReference, this.id])
    }

    getPrintableUrl() {
        return route('api.v2.hsqe.daily-briefings.download', [this.packageReference, this.id])
    }

    getFormAttributes() {
        return this.only(['date', 'locationOfWorks', 'keyActivities', 'keyHazards', 'givenByName', 'givenByPosition', 'packageName', 'packageReference', 'attendees', 'signature']);
    }

    static parseAttributes(attributes = {}) {
        return attributes
    }

    setAttributes(attributes) {
        super.setAttributes(attributes)
        this.formattedDate = moment(attributes.date).format('DD/MM/YYYY');
        let tokens = [this.givenByName, this.formattedDate,]
        this.tokens = tokens.join('|').toLowerCase();
        if (this.attendees) {
            this.attendees.sort((a, b) => a.order - b.order)
        }
    }

    static async find(packageReference, id) {
        const data = await Http.get(route('api.v2.hsqe.daily-briefings', [packageReference, id]))
        return this.make(data);
    }

    static async all(packageReference = null) {
        const params = {}
        const data = await Http.get(route('api.v2.hsqe.daily-briefings.list', [packageReference]), {params})
        return this.make(data)
    }

    static async create(packageReference, id, attributes = {}) {
        const success = await Http.post(route('api.v2.hsqe.daily-briefings.create', [packageReference, id]), attributes);
        const data = await Http.get(route('api.v2.hsqe.daily-briefings', [packageReference, id]))
        return this.make(data)
    }

    async update(attributes = {}) {
        const url = route('api.v2.hsqe.daily-briefings.store', [this.packageReference, this.id])
        const payload = this.constructor.parseAttributes({...this.getFormAttributes(), ...attributes})
        const success = await Http.put(url, payload)
        const data = await Http.get(route('api.v2.hsqe.daily-briefings', [this.packageReference, this.id]))
        return this.fill(data)
    }

    async send(attributes = {}) {
        const url = route('api.v2.hsqe.daily-briefings.send', [this.packageReference, this.id])
        let success
        try {
            success = await Http.post(url, attributes)
        } catch (error) {
            return error.response
        }
        const data = await Http.get(route('api.v2.hsqe.daily-briefings', [this.packageReference, this.id]))
        Object.assign(this, data)
        return success;
    }

    async revoke(sendRequestId) {
        const url = route('api.v2.hsqe.daily-briefings.revoke', [this.packageReference, this.id, sendRequestId])
        let success
        try {
            success = await Http.post(url, {})
        } catch (error) {
            return error.response
        }
        const data = await Http.get(route('api.v2.hsqe.daily-briefings', [this.packageReference, this.id]))
        Object.assign(this, data)
        return success;
    }

    async resend(sendRequestId) {
        const url = route('api.v2.hsqe.daily-briefings.resend', [this.packageReference, this.id, sendRequestId])
        let success
        try {
            success = await Http.post(url, {})
        } catch (error) {
            return error.response
        }
        const data = await Http.get(route('api.v2.hsqe.daily-briefings', [this.packageReference, this.id]))
        Object.assign(this, data)
        return success;
    }

    async requestSignature(attendeeId, to) {
        const url = route('api.v2.hsqe.daily-briefings.request-signature', [this.packageReference, this.id])
        const success = await Http.put(url, {attendeeId, to})
        const data = await Http.get(route('api.v2.hsqe.daily-briefings', [this.packageReference, this.id]))
        return this.fill(data)
    }

    async delete() {
        await Http.delete(route('api.v2.hsqe.daily-briefings.delete', [this.packageReference, this.id]))
    }
}
